import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=99c7d0a2&scoped=true"
import script from "./DownloadReport.vue?vue&type=script&lang=js"
export * from "./DownloadReport.vue?vue&type=script&lang=js"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&id=99c7d0a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c7d0a2",
  null
  
)

export default component.exports